import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import DashboardContainer from '../../components/admin/DashboardContainer';
import CreateOrUpdateCompanyForm from '../../components/admin/company/CreateOrUpdateCompanyForm';

import { supabase } from '../../supabaseClient';

export default function CreateOrUpdateCompany() {
  const { id } = useParams(); // Obtener el ID de la empresa de los parámetros de la URL
  const [companyData, setCompanyData] = useState(null);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const { data: companyData, error: companyError } = await supabase
          .from('companies')
          .select()
          .eq('id', id)
          .limit(1);

        if (companyError) {
          console.error(companyError);
          // Manejar el caso de error si es necesario
          return;
        }

        if (companyData.length === 1) {
          setCompanyData(companyData[0]);
        }

        const { data: sessionsData, error: sessionsError } = await supabase
          .from('sessions')
          .select()
          .eq('company', id)
          .order('date_from',{ascending: true})

        if (sessionsError) {
          console.error(sessionsError);
          // Manejar el caso de error si es necesario
          return;
        }
        setSessions(sessionsData);
      } catch (error) {
        console.error(error);
        // Manejar el caso de error si es necesario
      }
    };

    fetchCompanyData();
  }, [id]);

  return (
    <DashboardContainer title={companyData ? 'Actualizar Empresa' : 'Registrar Empresa'  }>
      <CreateOrUpdateCompanyForm companyData={companyData} sessions={sessions} setSessions={setSessions} />
    </DashboardContainer>
  );
}
